import { VisitDtoModelType } from '../models';

interface OrderProps {
  disabled: boolean;
  isLocked: boolean;
  isGeocoding: boolean;
  loading: boolean;
  isBeingModified: boolean;
  hasScheduled: boolean;
  hasUnscheduled: boolean;
  isUnscheduling: boolean;
  hasArrivedStop: boolean;
  hasCompleted: boolean;
  isScheduling: boolean;
  isQuestionable: boolean;
  isLandline: boolean;
  uuids: string[];
}

type OrdersPropsWithoutUuids = Omit<OrderProps, 'uuids'>;

const getProps = (cur: VisitDtoModelType) => ({
  disabled: cur.isDisabled,
  isGeocoding: cur.isGeocoding,
  isLocked: cur.locked,
  loading: cur.isBeingModified,
  hasScheduled: cur.isScheduled,
  hasUnscheduled: !cur.isScheduled,
  isScheduling: !!cur.isScheduling,
  isUnscheduling: !!cur.isUnscheduling,
  hasArrivedStop: cur.isArrivedStop,
  hasCompleted: cur.isCompleted,
  isQuestionable: cur.isQuestionable,
  isLandline: cur.isLandline,
});

const getOrdersProps = (orders: VisitDtoModelType[]) => orders.reduce((acc: OrderProps, cur: VisitDtoModelType) => {
  const currentOrderProps = getProps(cur);
  Object.entries(currentOrderProps).forEach(([key, value]) => {
    if (!acc[key as keyof OrdersPropsWithoutUuids] && value) {
      acc[key as keyof OrdersPropsWithoutUuids] = true;
    }
  });

  if (cur.uuid) {
    acc.uuids.push(cur.uuid);
  }
  return acc;
}, {
  disabled: false,
  isGeocoding: false,
  isLocked: false,
  loading: false,
  isBeingModified: false,
  hasScheduled: false,
  hasUnscheduled: false,
  isUnscheduling: false,
  hasArrivedStop: false,
  hasCompleted: false,
  isScheduling: false,
  isQuestionable: false,
  isLandline: false,
  uuids: [],
});

export default getOrdersProps;
